import { BACKEND_URI } from "../entries";
import { getCookie } from "../utils";
import { secureAPICall } from "../utils/sessionUtils";

// How many tickets the export would contain, for the dialog.
export const requestAiExportCount = async ({ dateFrom, dateTo, dateField, verbose = false }) => {
    const formData = new FormData();
    formData.append("date_from", dateFrom);
    formData.append("date_to", dateTo);
    formData.append("date_field", dateField);
    return secureAPICall({ endpoint: BACKEND_URI + "/api/export/ai-export-count", body: formData, verbose: verbose });
};

// Returns the ZIP as a Blob. Not secureAPICall: the success response is a file, not JSON.
export const requestAiExport = async ({ dateFrom, dateTo, dateField, profile, formats, includePii }) => {
    const formData = new FormData();
    formData.append("date_from", dateFrom);
    formData.append("date_to", dateTo);
    formData.append("date_field", dateField);
    formData.append("profile", profile);
    formats.forEach((f) => formData.append("formats", f));
    formData.append("include_pii", includePii);

    const response = await fetch(BACKEND_URI + "/api/export/ai-export", {
        method: "POST",
        body: formData,
        headers: { "X-CSRF-Token": getCookie("Mobile2CredentialsManager.CSRFToken") },
        credentials: "include",
    });
    if (!response.ok) {
        let detail = response.statusText;
        try {
            detail = (await response.json()).detail;
        } catch (e) {}
        throw { status: response.status, message: detail };
    }
    return response.blob();
};
